import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { popular_market_id: HotData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (HotData !== null) {
      if (HotData?.market === "Crypto") {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${HotData?.symbol}${HotData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if (HotData?.market === "Forex" || HotData?.market === "Metal") {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${HotData?.symbol}${HotData?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if (HotData?.market === "Stock") {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/us/markets/stocks/tickers/${HotData?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
    }
  };
  if (loading || HotData === null) {
    return ;
  }
  return (
    <>
      <div className="markets-coin">
        <Link to={`/user/live/trade/hot/${HotData?._id}`}>
          <div className="markets-coin-left">
            <div className="markets-coin-image">
              <LazyLoadImage
                effect="blur"
                alt="img"
                src={`https://api.wlffinance.org/${HotData?.image}`}
                className="hot-coin-img"
              />
            </div>
            <div className="markets-coin-name">
              <h4>{HotData?.name}</h4>
              <h5>{HotData?.symbol}</h5>
            </div>
          </div>
          <div className="markets-coin-right">
            <div className="markets-coin-price">
              <p>
                {livePrice?.lastQuote?.a || livePrice?.lastTrade?.p ? "$" : ""}

                {HotData?.market === "Forex" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                    parseFloat(HotData?.price)}
                {HotData?.market === "Metal" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                    parseFloat(HotData?.price)}
                {HotData?.market === "Crypto" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                    parseFloat(HotData?.price)}
                {HotData?.market === "Stock" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                    parseFloat(HotData?.price)}

                {livePrice?.lastQuote?.a === 0 ? (
                  <div className="market-closed">closed</div>
                ) : (
                  !livePrice?.lastQuote?.a &&
                  !livePrice?.lastTrade?.p && (
                    <div className="market-closed">closed</div>
                  )
                )}
              </p>
            </div>
            <div className="markets-coin-percentage">
              {livePrice?.todaysChangePerc && (
                <>
                  <p
                    className={`${
                      livePrice?.todaysChangePerc >= 0
                        ? "up-price"
                        : "dwon-price"
                    }`}
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                    {parseFloat(livePrice?.todaysChangePerc).toFixed(2)}%
                  </p>
                </>
              )}
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default SingleItem;
